<template>
  <div>
    <img
      src="@/assets/tarjeta_ofertas_ahorra_con_tu_taxi.jpg"
      style="width: 100%"
    />
    <p class="tituloTarjeta">AHORRA CON TU TAXI</p>

    <p></p>
    <p>
      Ahora, por tener tu taxi asegurado con nosotros,
      <b
        >al traer tus seguros de coche particular o de hogar a MMT, te mejoramos
        el precio del seguro de tu actual compañía.</b
      >
    </p>

    <p class="container-flex">
      <a href="tel:+ 34 91 594 88 86">
        <button
          class="pure-button botonLlamar"
          title="Pulse el botón para llamar a nuestro Centro de Atención al Cliente"
        >
          Llama e infórmate
        </button>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popUpConfirmTel: false,
    };
  },

  methods: {
    asunto() {
      return "ACTT";
    },
    confirmTel(val) {
      this.popUpConfirmTel = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
